require('../modules/core.dict');
module.exports = require('../modules/_core').Dict;


//////////////////
// WEBPACK FOOTER
// ../~/core-js/fn/dict.js
// module id = 886
// module chunks = 0